import React from 'react';
import { MessageCircle, Bell, ShoppingCart, Wallet, Crown } from 'lucide-react';
import { IconButton, AlertBadge } from './styled';

const IconButtons = ({
  unreadMessages,
  newNotifications,
  newProducts,
  notificationMenuOpen,
  notificationButtonRef,
  onIconClick,
}) => (
  <>
    <IconButton
      type="button"
      title="Subscription"
      onClick={() => onIconClick('subscription')}
    >
      <Crown size={18} strokeWidth={2} />
    </IconButton>
    <IconButton
      type="button"
      title="Wallet"
      onClick={() => onIconClick('wallet')}
    >
      <Wallet size={18} strokeWidth={2} />
    </IconButton>
    <IconButton
      type="button"
      title="Chat"
      onClick={() => onIconClick('chat')}
      className="hide-on-mobile"
    >
      <MessageCircle size={18} strokeWidth={2} />
      {unreadMessages > 0 && <AlertBadge>{unreadMessages}</AlertBadge>}
    </IconButton>
    <IconButton
      ref={notificationButtonRef}
      type="button"
      title="Notifications"
      onClick={() => onIconClick('notif')}
      aria-expanded={notificationMenuOpen}
      aria-haspopup="true"
    >
      <Bell size={18} strokeWidth={2} />
      {newNotifications > 0 && <AlertBadge>{newNotifications}</AlertBadge>}
    </IconButton>
    <IconButton
      type="button"
      title="Cart"
      onClick={() => onIconClick('cart')}
      className="hide-on-mobile"
    >
      <ShoppingCart size={18} strokeWidth={2} />
      {newProducts > 0 && <AlertBadge>{newProducts}</AlertBadge>}
    </IconButton>
  </>
);

export default IconButtons;

